<template>
  <div class="profile-upload-modal"
       v-if="visible" @click.self="handleWrapperClick">
    <div class="profile-upload-modal__dialog">
      <div class="profile-upload-modal__header">
        <span>{{title}}</span>
      </div>
      <div class="profile-upload-modal__body">
        <div class="upload">
          <p>
            <kendo-upload ref="upload"
                          name="files"
                          :select="onSelectFile"
                          :multiple="false"
                          :files="file"
                          :show-file-list="false"
                          :async-auto-upload="false"
                          :validation-allowed-extensions='[".gif", ".jpg", ".png"]'>
            </kendo-upload>
          </p>
          <div class="k-upload" v-show="file != ''">
            <ul class="k-upload-files">
              <li class="k-file">
                <span class="k-progress" style="width: 100%;"></span>
                <span class="pro_photo" id="previewImage"></span>
                <span class="k-file-state"></span>
                <span class="k-file-name-size-wrapper">
                  <span class="k-file-name" id="fileName"></span>
                  <span class="k-file-size" id="fileSize"></span>
                </span>
              </li>
            </ul>
            <!--  <label for="">적용사진 </label>
              <div class="pro_photo" id="previewImage"></div>-->
          </div>
          <div class="clear"></div>
          <p> 권장 사이즈는 110*110 픽셀이며 10MB 미만의 JPG, PNG, GIF 파일만 업로드가 가능합니다.</p>
        </div>

        <div class="btn_area">
          <button class="k-primary k-button" type="button" data-role="button" role="button" aria-disabled="false"
                  tabindex="0" @click="uploadFiles">등록
          </button>
          <button data-role="button" class="k-button" role="button" aria-disabled="false" tabindex="0"
                  @click="$emit('update:visible', !visible)">취소
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name   : 'profile-upload-modal',
    data () {
      return {
        template        : "<ul class=\"k-upload-files\"><li class=\"k-file\">" +
          "<span class=\"k-progress\" style=\"width: 100%;\"></span>" +
          "<span class=\"pro_photo\" id=\"previewImage\"></span>" +
          "<span class=\"k-file-state\"></span></span><span class=\"k-file-name-size-wrapper\">" +
          "<span class=\"k-file-name\">#=name#</span>" +
          "<span class=\"k-file-size\">#=size# KB</span></span> " +
          "</li></ul>",
        selectedFileName: file !== '' ? file[0].name : '',
        selectedFileSize: file !== '' ? file[0].size : '',
      }
    },
    props  : {
      visible: {
        type   : Boolean,
        require: true,
        default:
          false
      },
      title  : {
        type   : String,
        require: false,
      },
      file   : {
        default: []
      }
    },
    methods: {
      onSelectFile: function (e) {

        const fileInfo = e.files[0];
        this.file = fileInfo

        setTimeout(function () {
          const raw = fileInfo.rawFile;
          const reader = new FileReader();
          const name = fileInfo.name
          const w = this
          if (raw) {

            reader.onloadend = function () {

              w.document.getElementById("previewImage").innerHTML = "<img alt=" + name + " src=" + this.result + " style='max-width:100%;max-height: 100%;'>"
              w.document.getElementById("fileName").innerText = name
              w.document.getElementById("fileSize").innerText = `${fileInfo.size}KB`
            };

            reader.readAsDataURL(raw);
          }
        });
      },
      uploadFiles : function () {
        const upload = this.$refs.upload.kendoWidget();
        const files = upload.getFiles()

        const data = new FormData()
        files.forEach(function (v) {

          data.append("file", v.rawFile)
        })
        this.$emit('child', files)
        this.$emit('update:visible', false)

      },
      handleWrapperClick () {
        this.$emit('update:visible', false)
      },
    },
  }
</script>

<style>
  .profile-upload-modal {
    background-color: rgba(0, 0, 0, .7);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    overflow: auto;
    margin: 0;
  }

  .profile-upload-modal__dialog {
    left: 30%;
    top: 100px;

    position: absolute;
    background: #fff;
    margin-bottom: 50px;
  }

  .profile-upload-modal__header {
    font-size: 28px;
    font-weight: bold;
    line-height: 1.29;
    padding: 16px 16px 0 25px;
    position: relative;
  }

  .profile-upload-modal__body {
    padding: 25px;
    min-height: 150px;
    max-height: 412px;
    overflow-y: scroll;
  }

  .k-clear-selected, .k-upload-selected {
    display: none !important;
  }

  .image-preview {
    position: relative;
    vertical-align: top;
    height: 45px;
  }
</style>
